<template>
  <div class="resume-apply-success-page">
    <ResumeApplyDialog
      :resumeApplySuccessDialogShow="resumeApplySuccessDialogShow"
      :jobId="jobId"
      :assessment="assessment"
      :resumeApplyData="resumeApplyData"
    />
  </div>
</template>

<script>
import ResumeApplyDialog from '@/components/candidate/editor/resumeApplyDialog.vue'
import { mapActions } from 'vuex'
import { mixedRouterPush } from '@/router/routes'
export default {
  components: {
    ResumeApplyDialog
  },
  data () {
    return {
      needEditResume: null,
      resumeApplyData: {},
      resumeApplySuccessDialogShow: false,
      assessment: false
    }
  },
  computed: {
    jobId () {
      return this.$route.query.job_id
    }
  },
  created () {
    this.applyResume()
  },
  methods: {
    ...mapActions('personal', ['getResumeApplySuccessInfo']),
    async applyResume () {
      const params = { ...this.$route.query }
      if (params.assessment) {
        this.assessment = true
      }
      const resp = await this.getResumeApplySuccessInfo({ jobId: this.jobId, params: params })
      if (resp) {
        if (resp.apply_url) {
          mixedRouterPush(resp.apply_url)
          return
        }
        this.resumeApplyData = resp
        this.resumeApplySuccessDialogShow = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
